import { createContext, useState, useEffect } from "react";

// Crear el contexto
export const CartContext = createContext();

/* eslint-disable react/prop-types */
export const CartProvider = ({ children }) => {
    const [ cartItems, setCartItems ] = useState([]);
    const [ total, setTotal ] = useState(0);
    const [ costService, setCostService ] = useState(0);

    // Cargar el carrito desde sessionStorage al recargar la página
    useEffect(() => {
        const savedCart = sessionStorage.getItem("cart");
        if (savedCart) {
            setCartItems(JSON.parse(savedCart));
        }
    }, []);
    
    // Guardar el carrito en sessionStorage cada vez que cambie cartItems
    useEffect(() => {
        if (cartItems.length === 0) return;
        sessionStorage.setItem("cart", JSON.stringify(cartItems));
    }, [cartItems]);

     // Recalcular el total y el costo de servicio cada vez que cambie cartItems
     useEffect(() => {
        const totalPrice = cartItems.reduce((acc, item) => {
            return acc + item.precio * item.quantity;
        }, 0);
        setTotal(totalPrice);
        setCostService(totalPrice * 0.15); // 10% adicional por servicio
    }, [cartItems]);

    // Función para añadir items al carrito
    const addToCart = (newItem) => {
        setCartItems((prevItems) => {
            // Verificar si el item ya existe en la lista
            const existingItem = prevItems.find(
                (item) => item.id === newItem.id
            );

            if (existingItem) {
                // Si el item ya existe, actualizar la cantidad
                const updatedItems = prevItems.map((item) =>
                    item.id === newItem.id
                        ? { ...item, quantity: newItem.quantity }
                        : item
                );

                // Si la cantidad del item actualizado es 0, lo eliminamos
                return updatedItems.filter((item) => item.quantity > 0);
            } else {
                // Si el item no existe y la cantidad es mayor a 0, lo agregamos
                return newItem.quantity > 0
                    ? [...prevItems, newItem]
                    : prevItems;
            }
        });
    };

    const removeItem = (id) =>{
        cartItems.find((item)=>{
            if (item.id === id ){
                setCartItems(cartItems.filter((item)=> item.id !== id))
            }
        })
    }

    const cleanCart = () =>{
        setCartItems([])
    }

    // Proveer el estado y la función en todo el árbol de componentes
    return (
        <CartContext.Provider value={{ cartItems, addToCart, removeItem, cleanCart, total, costService }}>
            {children}
        </CartContext.Provider>
    );
};
